import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, Validators} from '@angular/forms';
import {ExternalEmployeeService} from '../../../services/external-employee.service';
import {Router} from '@angular/router';
import {AppSettingsService} from '../../../services/app-settings.service';
import {UploadInfo} from '../../../model/GeneralModels';

@Component({
  selector: 'app-introduction-letter-employee-response',
  templateUrl: './introduction-letter-employee-response.component.html',
  styleUrls: ['./introduction-letter-employee-response.component.css']
})
export class IntroductionLetterEmployeeResponseComponent implements OnInit {
  @Input() id: number;
  @Input() translation: any;
  newReplyPanelStatus: boolean;
  testFormGroup = this.fb.group({
    requestedFileType: ['', Validators.required]
  });
  @Input() status: string;
  upload: boolean;
  @Input() show: boolean;
  fileInfo: UploadInfo;

  constructor(private fb: FormBuilder, private service: ExternalEmployeeService,
              private router: Router, public settings: AppSettingsService) { }

  ngOnInit(): void {
  }

  submitReply(reply: string) {
    if ((reply === 'TEST' && this.testFormGroup.valid) || reply === 'REJECT') {
      this.service.submitReply(this.id, 'INTRODUCTION_LETTER', reply, this.testFormGroup.controls.requestedFileType.value)
        .subscribe(response => {
          if (response.success) {
            this.router.navigate([`/external-employee/INTRODUCTION_LETTER`]);
          }
        });
    }
  }

  fileChanged(file: File) {
    this.service.releaseIntroductionLetter(this.id, 'INTRODUCTION_LETTER', file).subscribe(response => {
      if (response.success) {
        this.router.navigate([`/external-employee/INTRODUCTION_LETTER`]);
      }
    });
  }

  hideUploadPanel() {
    this.fileInfo = null;
  }

  showUpload() {
    this.fileInfo = {
      persianName: 'فایل ' + this.settings.translateEnglish('INTRODUCTION_LETTER', this.translation),
      englishName: 'INTRODUCTION_LETTER',
      id: this.id
    };
  }
}
